import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface AgencyDocumentSummary {
  totalPlatformAndCompanyDocumentsToUpload: number;
  totalPlatformAndCompanyDocumentUploaded: number;
  totalPlatformAndCompanyDocumentApproved: number;
  totalPlatformAndOwnerDocumentsToUpload: number;
  totalPlatformAndOwnerDocumentUploaded: number;
  totalPlatformAndOwnerDocumentApproved: number;
  totalPlatformAndOtherDocumentsToUpload: number;
  totalPlatformAndOtherDocumentUploaded: number;
  totalPlatformAndOtherDocumentApproved: number;
  totalLenderDocumentsToUpload: number;
  totalLenderDocumentUploaded: Record<string, number>;
}

export interface AgencyDocumentSummaryState {
  data: AgencyDocumentSummary | null;
  loading: boolean;
  error: string | null;
}

export const agencyDocumentSummaryState: AgencyDocumentSummaryState = {
  data: null,
  loading: false,
  error: null,
};

const agencyDocumentSummary = createSlice({
  name: 'agencyDocumentSummary',
  initialState: agencyDocumentSummaryState,
  reducers: {
    fetchAgencyDocumentSummaryRequest: (
      state,
      action: PayloadAction<string>
    ) => {
      state.loading = true;
      state.error = null;
    },
    fetchAgencyDocumentSummarySuccess: (
      state,
      action: PayloadAction<AgencyDocumentSummary>
    ) => {
      state.data = action.payload;
      state.loading = false;
    },
    fetchAgencyDocumentSummaryFailure: (
      state,
      action: PayloadAction<string>
    ) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  fetchAgencyDocumentSummaryRequest,
  fetchAgencyDocumentSummarySuccess,
  fetchAgencyDocumentSummaryFailure,
} = agencyDocumentSummary.actions;

export default agencyDocumentSummary.reducer;
